import { SON_ISLEM_SIL } from "../constants/requestUrls";

import { postRequest } from "../request";

const deleteLastEvent = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: SON_ISLEM_SIL, data });
}

export default deleteLastEvent;